import React, { useRef, useContext, useEffect } from "react";
import { Box, Paper, Stack } from "@mui/material";
import { useSpring, animated } from "react-spring";
import QuestionModal from "./QuestionModal";
import { QuestionsContext } from "../../../../../../provider/MyContexts";
import { Question } from "../../../../../../type";
import { focusCell } from "../../../../../../commands/common";
import { getQuestionIds, getQuestionRange } from "../../../../../../commands/questions/excelInfo";

type Props = {
  openEditor: boolean;
  windowHeight: number;
  foldDetailWindow: () => void;
  unfoldDetailWindow: () => void;
  setWindowHeight: (height: number) => void;
};

export const MIN_HEIGHT = 24;
export const MAX_HEIGHT = 798;

export default function DetailWindow(props: Props) {
  const { openEditor, windowHeight, foldDetailWindow, unfoldDetailWindow, setWindowHeight } = props;

  // const [windowHeight, setWindowHeight] = React.useState(0);

  // function foldDetailWindow() {
  //   if (openEditor) {
  //     setWindowHeight(MIN_HEIGHT - 1);
  //   }
  // }
  // function unfoldDetailWindow() {
  //   setWindowHeight(600);
  // }

  const { selectedQuestion, getNextQuestion, questions, editSheet } = useContext(QuestionsContext);

  const isDragging = useRef(false);
  const startY = useRef(0);
  const startHeight = useRef(0);

  const springStyles = useSpring({
    transform: openEditor ? `translateY(0%)` : `translateY(100%)`,
    // transform: openEditor && !isDragging.current ? `translateY(0%)` : `translateY(100%)`,
    // config: { tension: 300, friction: 30 },
  });
  // const [springStyles, api] = useSpring(() => ({
  //   height: MIN_HEIGHT,
  //   transform: openEditor ? `translateY(0%)` : `translateY(100%)`,
  // }));

  const handleMouseDown = (e: React.MouseEvent) => {
    isDragging.current = true;
    startY.current = e.clientY;
    startHeight.current = windowHeight;

    document.body.style.userSelect = "none"; // 範囲選択防止

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging.current) return;
      const delta = e.clientY - startY.current;
      const newHeight = Math.min(Math.max(startHeight.current - delta, MIN_HEIGHT), MAX_HEIGHT);

      setWindowHeight(newHeight);
    };

    const handleMouseUp = () => {
      isDragging.current = false;
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  async function setFocusOnQuestion(question: Question, editSheet: string) {
    const nextQuestion = questions[getNextQuestion()];

    try {
      const { excel } = await getQuestionIds(questions, editSheet);

      const lastQuestionIdInExcel = excel[excel.length - 1];

      const { rangeText } = await getQuestionRange(
        question,
        lastQuestionIdInExcel !== question.questionId ? nextQuestion.questionId : undefined,

        editSheet
      );
      await focusCell(rangeText, editSheet);
    } catch (error) {
      console.error("Error focusing on question:", error);
      // Optionally, you can handle the error here, e.g., show a notification
    }
  }

  useEffect(() => {
    if (selectedQuestion && editSheet) {
      setFocusOnQuestion(selectedQuestion, editSheet);
    }
  }, [selectedQuestion, editSheet]);

  useEffect(() => {
    if (openEditor) {
      unfoldDetailWindow();
    }
  }, [openEditor]);

  if (!selectedQuestion) {
    return <></>; // 何も選択されていない場合は何も表示しない
  }

  return (
    <animated.div
      style={{
        ...springStyles,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          overflow: "hidden",
          position: "relative",
          zIndex: 1300,
        }}
      >
        {/* ドラッグハンドル */}
        <Box
          onMouseDown={handleMouseDown}
          sx={{
            height: 24,
            cursor: "ns-resize",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f0f0f0",
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 4,
              borderRadius: 2,
              backgroundColor: "gray",
            }}
          />
        </Box>
        {windowHeight > MIN_HEIGHT && (
          <Stack height={windowHeight} width={"100%"}>
            <QuestionModal foldDetailWindow={foldDetailWindow} />
          </Stack>
        )}
      </Paper>
    </animated.div>
  );
}
